<template>
  <footer class="site-footer">
    <div class="footer-shell">
      <div class="footer-brand">
        <span class="footer-kicker">FreeGame</span>
        <h2>A sharper arcade front end for modern browser play.</h2>
        <p>
          The site shell now uses a darker, more editorial visual system while keeping the original
          game directory intact. Discovery, entry, and moment-to-moment browsing all feel more refined.
        </p>
      </div>

      <div class="footer-links">
        <router-link to="/contact">Contact</router-link>
        <router-link to="/terms">Terms</router-link>
        <router-link to="/privacy">Privacy</router-link>
        <router-link to="/about">About</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "GameFooter"
}
</script>

<style scoped>
.site-footer {
  padding: 12px 0 40px;
}

.footer-shell {
  width: min(1240px, calc(100% - 40px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 20px;
  padding: 26px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background:
    radial-gradient(circle at top right, rgba(255, 143, 112, 0.16), transparent 28%),
    linear-gradient(180deg, rgba(17, 19, 24, 0.92), rgba(7, 8, 10, 0.98));
}

.footer-kicker {
  display: inline-block;
  margin-bottom: 12px;
  color: rgba(226, 232, 240, 0.68);
  font: 600 11px/1 "Courier New", monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.footer-brand h2 {
  margin-bottom: 12px;
  color: #f8fafc;
  font: 700 clamp(28px, 3vw, 40px)/1.05 Georgia, serif;
  letter-spacing: -0.03em;
}

.footer-brand p {
  max-width: 48rem;
  color: rgba(226, 232, 240, 0.76);
  font-size: 15px;
  line-height: 1.8;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.footer-links a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #f8fafc;
  background: rgba(255, 255, 255, 0.03);
}

@media (max-width: 780px) {
  .footer-shell {
    width: min(100%, calc(100% - 24px));
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GameFooter.vue